module.exports = __webpack_public_path__ + "img/logo_white_tranparent_25.94ee2eb7.svg";